import { render, staticRenderFns } from "./MarketOverview.vue?vue&type=template&id=d98a8826&scoped=true"
import script from "./MarketOverview.vue?vue&type=script&lang=js"
export * from "./MarketOverview.vue?vue&type=script&lang=js"
import style0 from "./MarketOverview.vue?vue&type=style&index=0&id=d98a8826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98a8826",
  null
  
)

export default component.exports